import { SeriesItem } from './series-reducer';

export const normalizeData = (points: SeriesItem['data']): SeriesItem['data'] => {
  return points
    .filter((pt) => pt.value != null)
    .sort((a, b) => a.time - b.time)
    .filter((pt, i, arr) => i === 0 || pt.time !== arr[i - 1].time);
};
